import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import MainService from '../../../service/main/main';
import { formatDate3 } from '../../../func/func';

interface YoutubeItem {
  thumbnails: string;
  title: string;
  link: string;
  publishedAt: string;
}

function Youtube() {
  const [youtubeList, setYoutubeList] = useState<YoutubeItem[]>(); // 유튜브 리스트
  const [youtubeList2, setYoutubeList2] = useState<YoutubeItem[]>(); // 경매는 타이밍 유튜브

  const getYoutubeData = async () => {
    try {
      const result = await MainService.youtube('땅집고');
      setYoutubeList(result.data);
      // const res2 = await MainService.youtube('경매는타이밍');
      // setYoutubeList2(res2.data);
    } catch (error) {
      console.error('Error fetching youtube data:', error);
    }
  };

  useEffect(() => {
    getYoutubeData();
  }, []);

  return (
    <Container>
      <Inner>
        <Section>
          <Header
            onClick={() =>
              window.open('https://youtube.com/@ddangzipgo?feature=shared')
            }
          >
            <img
              src="/assets/images/icon/youtube.svg"
              alt="youtube"
              width={27}
              height={20}
            />
            <Title>땅집고 {'>'}</Title>
          </Header>
          <YoutubeList>
            {youtubeList &&
              youtubeList.map((item) => (
                <Card key={item.link} onClick={() => window.open(item.link)}>
                  <Thumbnail src={item.thumbnails} />
                  <CardDescrption>
                    <CardTitle>{item.title}</CardTitle>
                    <Date>{formatDate3(item.publishedAt)}</Date>
                  </CardDescrption>
                </Card>
              ))}
          </YoutubeList>
        </Section>
      </Inner>
    </Container>
  );
}

export default Youtube;

const Container = styled.div`
  width: 100%;
  background: #fff;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  width: 100%;
  height: 100%;
  padding: 32px 16px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 145%; /* 26.1px */
  letter-spacing: -0.36px;
`;

const YoutubeList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
`;

const Card = styled.div`
  display: flex;
  min-width: 282px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

const Thumbnail = styled.img`
  width: 100%;
  height: 158px;
  object-fit: cover;
`;

const CardDescrption = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;

const Date = styled.div`
  color: var(--semantic-label-neutral, #616161);
  font-size: 14px;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;
